<div class="groups-items-item-label">
  <div *ngIf="group.isChangedName" [class.isAnyChanged]="group.isChangedName">*</div>
  <div class="group-image" [class.group-img__default]="!group.externalPictureUrl">
    <img alt="product name" [src]="group.externalPictureUrl ? group.externalPictureUrl : defaultPicture"/>
  </div>
  <div class="groups-items-item-name">
    {{ groupName }}
    <span class="groups-items-item-description">
      {{ groupDescription }}
    </span>
  </div>
  <div class="groups-items-item-delete-btn">
    <button [matMenuTriggerFor]="menu" mat-icon-button>
      <mat-icon class="groups-items-item-more">more_horiz</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onOpenEditGroupDialog()">
        <mat-icon>edit</mat-icon>
        <span>{{ "MENU.EDIT" | translate }}</span>
      </button>
      <button mat-menu-item (click)="onOpenSchedulesGroupDialog()">
        <mat-icon>schedule</mat-icon>
        <span>{{ "MENU.SCHEDULES" | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>
<div class="group-dishes-cards">
</div>
